import { Link } from "react-router-dom";
import { ArrowRight, Sparkles } from "lucide-react";
import { AnimatedBotWidget } from "./AnimatedBotWidget";

export const Hero = () => (
  <section className="relative pt-16 pb-16 px-4 sm:px-6 overflow-hidden">
    <div className="max-w-7xl mx-auto">
      <div className="max-w-3xl mx-auto text-center animate-fade-up">
        <span
          data-testid="hero-badge"
          className="inline-flex items-center gap-2 bg-blue-50 text-blue-700 border border-blue-200 text-xs sm:text-sm font-bold px-4 py-1.5 rounded-full mb-8"
        >
          <Sparkles className="w-4 h-4" />
          12,400+ traders matched with their perfect trading platform
        </span>
        <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight text-gray-900 leading-[1.05]">
          AI-Powered Trading Software,
          <br />
          <span className="text-blue-600">Matched With the Right Trading Platform for You.</span>
        </h1>
        <p className="mt-6 text-base md:text-lg leading-relaxed text-gray-600 max-w-2xl mx-auto">
          No more guesswork. No more endless comparisons. AI Central analyzes your trading style,
          goals and experience — then routes you to the trading platform that fits you best.
        </p>
        <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/confirmation"
            data-testid="hero-cta-btn"
            className="inline-flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white font-bold px-8 py-4 rounded-full text-base transition-all duration-200 hover:scale-105 shadow-lg shadow-blue-600/25"
          >
            Activate My Account
            <ArrowRight className="w-5 h-5" />
          </Link>
          <a
            href="#client-journey"
            onClick={(e) => {
              e.preventDefault();
              document.getElementById("client-journey")?.scrollIntoView({ behavior: "smooth" });
            }}
            data-testid="hero-secondary-btn"
            className="inline-flex items-center gap-2 bg-white hover:bg-gray-50 text-gray-900 font-bold px-8 py-4 rounded-full text-base border border-gray-300 transition-all duration-200"
          >
            See How It Works
          </a>
        </div>
        <p className="mt-4 text-sm text-gray-500">
          Free to use · 60-second profile · Regulated trading platforms only
        </p>
      </div>

      <div className="mt-14 max-w-4xl mx-auto animate-fade-up" style={{ animationDelay: "0.2s" }}>
        <AnimatedBotWidget />
      </div>
    </div>
  </section>
);
